<template>
  <div class="text">
    * <slot></slot>
  </div>
</template>

<script>
export default {
  name: "Tip",
};
</script>

<style>
.text{
  color:red;
  font-size: 13px;
  margin: -10px 0 5px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Tip.vue